// extracted by mini-css-extract-plugin
export default {"fullVideo":"BgVideos_fullVideo__rR8zW","unVisible":"BgVideos_unVisible__ZeWlG","leftVideo":"BgVideos_leftVideo__5jhoG"};